import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CollapsibleBlock from "src/components/CollapsibleBlock/CollapsibleBlock";
import AttachmentsSelector from "src/components/AttachmentsSelector/AttachmentsSelector";
import useCollapsibles from "src/hooks/useCollapsibles";
import { MdOutlineAttachment } from "react-icons/md";
import { ICON_SIZES } from "src/constants/icons";

interface IMoneyTransferAttachments {
  attachments: Array<any>;
  onChange: (data: any) => void;
  onClick: (data: any) => void;
}

const MoneyTransferAttachments: React.FC<IMoneyTransferAttachments> = ({
  attachments,
  onChange,
  onClick,
}) => {
  const { t } = useTranslation();
  const [totalFiles, setTotalFiles] = useState<number>(0);
  const [unsavedAttachments, setUnsavedAttachments] = useState<any[]>([]);

  const { updateCollapsible, collapsiblePreferences } = useCollapsibles();

  useEffect(() => {
    setTotalFiles(unsavedAttachments?.length + attachments?.length);
  }, [unsavedAttachments, attachments]);

  return (
    <CollapsibleBlock
      keepAlive
      title={t("misc:attachments_selector.collapsible.title")}
      badge={
        totalFiles
          ? t("misc:attachments_selector.collapsible.count", {
              count: totalFiles,
            })
          : t("misc:attachments_selector.collapsible.no_attachments")
      }
      // open={collapsiblePreferences.moneyTransferAttachmentsOpen}
      blocked
      open
      onChange={(isOpen: boolean) => {
        updateCollapsible({ moneyTransferAttachmentsOpen: isOpen });
      }}
      uppercase
      icon={<MdOutlineAttachment size={ICON_SIZES.SM} />}
    >
      <>
        <AttachmentsSelector
          savedAttachments={[]}
          onChange={(data: any) => {
            setUnsavedAttachments(data?.unsaved);
            onChange(data);
          }}
          onClick={(data: any) => onClick(data)}
        />
      </>
    </CollapsibleBlock>
  );
};

export default MoneyTransferAttachments;
